var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.941 11.679a3.664 3.664 0 0 0 5.526.395l2.199-2.198a3.664 3.664 0 0 0-5.181-5.182l-1.261 1.254",
  stroke: "#455273",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.874 10.213a3.665 3.665 0 0 0-5.526-.396L4.15 12.016a3.665 3.665 0 0 0 5.181 5.181l1.253-1.253",
  stroke: "#455273",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLink20;